$( ".breadcrumb" ).click(function() {
    $(this).removeClass('ellipsis');
});